import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ListGroup } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Stack from 'react-bootstrap/Stack';
import { useAuth } from '../../../providers/auth-provider';
import { getUserByReference, isStaffingCandidate } from '../../../api/dashboards-api';

function ReportsMenu({ reference }) {
  const auth = useAuth();
  const [isStaffing, setStaffing] = useState(false);

  useEffect(() => {
    getUserByReference(auth, reference).then((candidate) => {
      setStaffing(isStaffingCandidate(candidate));
    });
  }, []);

  return (
    <Container className="ps-0 pe-0">
      {auth.isDevelop() ? (
        <>
          <Stack className="text-bold text-larger pt-5 pb-4 w-100 text-center">Leadership Reports</Stack>
          <ListGroup>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/leader/development/${reference}`}
            >
              Leader&apos;s Development Report
              <div className="candidate-report-description">{`Reporting & coaching tips for leader`}</div>
            </ListGroup.Item>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/leader/manager/${reference}`}
            >
              Leader&apos;s Manager Report
              <div className="candidate-report-description">{`Reporting & coaching tips for leader's manager`}</div>
            </ListGroup.Item>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/leader/coaching/${reference}`}
            >
              Leader&apos;s Coaching Report
              <div className="candidate-report-description">
                {`Comprehensive reporting & coaching tips for leader's coach`}
              </div>
            </ListGroup.Item>
          </ListGroup>
        </>
      ) : !isStaffing ? (
        <>
          <Stack className="text-bold text-larger pt-5 pb-4 w-100 text-center">Candidate/New Hire Reports</Stack>
          <ListGroup>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/candidate/profile/${reference}`}
            >
              Candidate Profile Report
              <div className="candidate-report-description">Reporting & hiring recommendation for candidate</div>
            </ListGroup.Item>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/candidate/development/${reference}`}
            >
              Candidate Development Report
              <div className="candidate-report-description">Coaching tips for candidates not hired</div>
            </ListGroup.Item>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/new-hire/development/${reference}`}
            >
              New Hire Development Report
              <div className="candidate-report-description">Coaching tips for hired candidate</div>
            </ListGroup.Item>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/new-hire/manager/${reference}`}
            >
              New Hire Manager Report
              <div className="candidate-report-description">{`Reporting & coaching tips for hired candidate's manager`}</div>
            </ListGroup.Item>
            <ListGroup.Item
              as={Link}
              action
              className="text-bold"
              variant="primary"
              to={`/report/new-hire/coaching/${reference}`}
            >
              New Hire Coaching Report
              <div className="candidate-report-description">{`Comprehensive reporting & coaching tips for hired candidate's coach`}</div>
            </ListGroup.Item>
          </ListGroup>
        </>
      ) : (
        <>
          <Stack className="text-bold text-larger pt-5 pb-4 w-100 text-center">Candidate/New Hire Reports</Stack>
          <ListGroup>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/candidate/profile/${reference}`}
            >
              Candidate Profile Report
              <div className="candidate-report-description">Reporting & hiring recommendation for candidate</div>
            </ListGroup.Item>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/candidate/development/${reference}`}
            >
              Candidate Development Report
              <div className="candidate-report-description">Coaching tips for candidates not hired</div>
            </ListGroup.Item>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/new-hire/manager/${reference}?staffing=onsite`}
            >
              New Hire Manager Report (ONSITE/HYBRID)
              <div className="candidate-report-description">{`Reporting & coaching tips for hired candidate's manager`}</div>
            </ListGroup.Item>
            <ListGroup.Item
              as={Link}
              className="text-bold"
              action
              variant="primary"
              to={`/report/new-hire/manager/${reference}?staffing=remote`}
            >
              New Hire Manager Report (REMOTE)
              <div className="candidate-report-description">{`Reporting & coaching tips for hired candidate's manager`}</div>
            </ListGroup.Item>
          </ListGroup>
        </>
      )}
    </Container>
  );
}

export default ReportsMenu;
